import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  propertyType: {
    padding: '24px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
    gap: '16px',
  },
  propertyTypeHeading: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.evPalette.charcoal[800],
  },
  propertyTypeRow: {
    columnGap: '16px',
  },
  complexCheckbox: {
    columnGap: '8px',
    '& >label': { cursor: 'pointer', fontSize: '14px' },
    '& >.myev-MuiIconButton-root': { padding: '9px 0' },
  },
  complexTooltipLink: {
    fontWeight: 600,
    color: theme.evPalette.ocean[400],
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  propertyTypeRadio: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    '& >label': { cursor: 'pointer', fontSize: '14px' },
    '& >.myev-MuiIconButton-root': { padding: '9px 0' },
  },
  complexAlert: {
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    '& >.myev-MuiAlert-icon': { color: theme.evPalette.ocean[600] },
  },
}));
